import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Main from './Main';
import Login from './singup/Login';
import Join from './singup/Join';
import Faq from './customerCenter/Faq';
import Inquiry from './customerCenter/Inquiry';
import Comeon from './customerCenter/Comeon';
import TourMap from './stamptour/TourMap';
import Notice from './stamptour/Notice';
import EvtNoti from './stamptour/EvtNoti';
import EntryPoint from './mypage/EntryPoint';
import MyPage from './mypage/MyPage';
import Download from './customerCenter/Download';
import MyInfoMod from './mypage/MyInfoMod';
import StampBook from './introduction/StampBook';
import Verify from './introduction/Verify';
import Souvenir from './introduction/Souvenir';
import Stamp from './introduction/Stamp';
import Doowon from './introduction/Doowon';
import CeoMsg from './compInfo/CeoMsg';
import CompHistory from './compInfo/CompHistory';
import AboutDw from './compInfo/AboutDw';
import Philosophy from './compInfo/Philosophy';

const routes = (props) => {
  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" component={Main} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/join" component={Join} />
        <Route exact path="/faq" component={Faq} />
        <Route exact path="/Inquiry" component={Inquiry} />
        <Route exact path="/Contactus" component={Comeon} />
        <Route exact path="/TourMap" component={TourMap} />
        <Route exact path="/notice" component={Notice} /> {/* 스탬프투어->공지   */}
        <Route exact path="/evtnoti" component={EvtNoti} /> {/* 스탬프투어->이벤트   */}
        <Route exact path="/EntryPoint/:id" component={EntryPoint} />
        <Route exact path="/mypage" component={MyPage} />
        <Route exact path="/download" component={Download} />
        <Route exact path="/profile" component={MyInfoMod} />
        <Route exact path="/stampbook" component={StampBook} />
        <Route exact path="/verify" component={Verify} />
        <Route exact path="/souvenir" component={Souvenir} />
        <Route exact path="/stamp" component={Stamp} />
        <Route exact path="/Doowon" component={Doowon} />
        <Route exact path="/ceoMsg" component={CeoMsg} />
        <Route exact path="/compHistory" component={CompHistory} />
        <Route exact path="/aboutdw" component={AboutDw} />
        <Route exact path="/philosophy" component={Philosophy} />
      </Switch>
    </HashRouter>
  );
};

export default routes;
